import React from 'react';
import _ from 'lodash';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useLocation } from 'react-use';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCalendar, faCogs, faDollarSign, faFile, faFileAlt, faSchool, faSignOut, faUser } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Avatar, Dropdown, Menu } from 'antd';
import Logo from '../logo/Logo';
import WebLogo from '../../../assets/images/logo/web.png';
import { menuSideBarAtom, userAtom, tokenAtom, userPrivilagesAtom, userOrganizationsAtom } from '../../../atoms/Atoms';
import LanguagePicker from '../language-picker/LanguagePicker';
import envConfig from '../../../envConfig';
import './header.css';  

function Header() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [user, setUser] = useRecoilState(userAtom);
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const userOrganizations = useRecoilValue(userOrganizationsAtom);
  const setToken = useSetRecoilState(tokenAtom);
  const [isMenuOpen, setIsMenuOpen] = useRecoilState(menuSideBarAtom);
  // const hideMenu = location.pathname !== '/' ? _.filter(envConfig.HideMenuLocations, (l) =>
  //   location.pathname.startsWith(l)).length >= 1 : true;
  const hideMenu = false;
  // const showLogo = _.filter(envConfig.HideHeaderLogo, (l) =>
  //   location.pathname.startsWith(l)).length >= 1;
  const showLogo = true;

  function signOut() {
    const promise = new Promise(function (resolve, reject) {
      setIsMenuOpen(false);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-user`);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-token`);
      setToken(null);
      resolve();
    });
    promise.then(() => {
      setUser(null);
    })
    .then(() => {
      history.push('/');
    });
  }

  return ( 
    <header className="header-main h-20 py-2 px-4">
      <div className="flex w-full">
        {showLogo && (
          <Logo
            className="w-28 m-4 p-2 md:w-28 hover:scale-110"
          />
        )}
        {!showLogo && (
           <p className="mx-4 font-semibold text-3xl text-white">Go Solar Puerto Rico</p>
        )}
        <div className="text-white ml-auto flex divider-x space-x-4">
          <LanguagePicker className="mt-4 hidden md:block" />
          <div className="hidden md:block">
            {!user && (
              <button type="button" className="mt-5 underline" onClick={() => history.push('/login')}>
                {t('sign_in')}
              </button>
            )}
            {user && (
              <Dropdown
                overlay={
                  <Menu mode="inline" className="p-0">
                    <Menu.Item
                      id="profile"
                      className="text-xs flex items-center"
                      onClick={() => {
                        history.push('/profile')
                      }}
                    >
                      <FontAwesomeIcon className="mr-3" icon={faUser} />
                      {t('profile')}
                    </Menu.Item>
                    {userPrivilages.hasAdminPrivilages && (
                      <Menu.Item
                        id="learningcenter"
                        className="text-xs flex items-center"
                        onClick={() => {
                          history.push('/learning')
                        }}
                      >
                        <FontAwesomeIcon className="mr-3" icon={faSchool} />
                        {t('learning_center')}
                      </Menu.Item>
                    )}
                    {userPrivilages.hasCloserAdminPrivilages && (
                      <Menu.Item
                        id="admin"
                        className="text-xs flex items-center"
                        onClick={() => {
                          history.push('/admin')
                        }}
                      >
                        <FontAwesomeIcon className="mr-3" icon={faCogs} />
                        {t('admin')}
                      </Menu.Item>
                    )}
                    {userPrivilages.hasCloser && (
                      <>
                        <Menu.Item
                          id="leads"
                          className="text-xs flex items-center"
                          onClick={() => {
                            history.push('/leads')
                          }}
                        >
                          <FontAwesomeIcon className="mr-3" icon={faFileAlt} />
                          {t('my_opportunities')}
                        </Menu.Item>
                        <Menu.Item
                          id="my_calendar"
                          className="text-xs flex items-center"
                          onClick={() => {
                            history.push('/my/calendar')
                          }}
                        >
                          <FontAwesomeIcon className="mr-3" icon={faCalendar} />
                          {t('my_calendar')}
                        </Menu.Item>
                      </>
                    )}
                    {userPrivilages.hasLeadManager && (
                      <Menu.Item
                        id="leadsmanager"
                        className="text-xs flex items-center"
                        onClick={() => {
                          history.push('/leads/unassigned')
                        }}
                      >
                        <FontAwesomeIcon className="mr-3" icon={faFileAlt} />
                        {t('unassigned_leads')}
                      </Menu.Item>
                    )}
                    {userPrivilages.hasSetter && (
                      <Menu.Item
                        id="setterleads"
                        className="text-xs flex items-center"
                        onClick={() => {
                          history.push('/setter/leads')
                        }}
                      >
                        <FontAwesomeIcon className="mr-3" icon={faFileAlt} />
                        {t('my_leads')}
                      </Menu.Item>
                    )}
                    {(userPrivilages.hasSetter || userPrivilages.hasCloser) && (
                      <Menu.Item
                        id="my_commissions"
                        className="text-xs flex items-center"
                        onClick={() => {
                          history.push('/my/commissions')
                        }}
                      >
                        <FontAwesomeIcon className="mr-3" icon={faDollarSign} />
                        {t('my_commissions')}
                      </Menu.Item>
                    )}
                    <Menu.Item
                      id="logout"
                      className="text-xs flex items-center"
                      onClick={() => {
                        signOut();
                      }}
                    >
                      <FontAwesomeIcon className="mr-3" icon={faSignOut} />
                      {t('sign_out')}
                    </Menu.Item>
                  </Menu>
                }
              >
                <div className="px-4 py-3 flex rounded rounded-md items-center space-x-3 text-sm tracking-tight transition-colors duration-200 ease-linear text-white hover:bg-sidebarSelected hover:text-primaryColor ring-0 focus:ring-0 outline-none focus:outline-none">
                  <Avatar className="bg-primaryColor" src={user?.avatar} />
                  <div>{user?.completeName}</div>
                </div>
              </Dropdown>
            )}
          </div>
        </div>
        {!hideMenu && (
          <button
            aria-label="sidemenu"
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden hover:scale-110 text-headerText transform h-10 w-10 px-2 rounded-md text-xl transition duration-200 ease-in-out ring-0 outline-none focus:ring-0 focus:outline-none"
          >
            <FontAwesomeIcon icon={faBars} className="text-headerText" />
          </button>
        )}
      </div>
    </header>
  )
} 

export default Header;
